<template>
    <div>
        <component-wrapper :config="component" @click.native="triggerBooking" />
        <bottom-dialog v-model="showBookingDialog" max-width="850px" :dialog="!$vuetify.breakpoint.mobile">
            <v-card class="zoezi-bottom-sheet course-booking-sheet-card" elevation="0">
                <course-booking v-if="showBookingDialog" ref="courseBooking" :courseId="courseId" :showSpaceLeft="showSpaceLeft" :skip-info="!showInfoPopupDialog" dialog @close="closeBookingDialog" />
            </v-card>
        </bottom-dialog>
    </div>
</template>

<script>
import components from '../component.js';
import CourseBooking from "./CourseBooking.vue";
import BottomDialog from '../components/BottomDialog.vue';

export default {
    name: "zoezi-course-booking-button",
    zoezi: {
        title: 'Course booking button',
        icon: 'mdi-book',
        addon: 'Courses'
    },
    components: {
        CourseBooking,
        BottomDialog,
    },
    props: {
        component: {
            title: 'Component',
            type: Object,
            fulltype: 'component',
            default: () => components.makeEmptyConfig({ component: 'zoezi-button', props: { text: 'Book' } })
        },
        courseId: {
            title: 'Course',
            type: Number,
            fulltype: 'select',
            typeinfo: {
                multiple: false,
                text: 'name',
                value: 'id',
                getItems: () => window.$zoeziapi.get('/api/public/course/get', {bookable:true}).then(courses => courses.map(course => ({ id: course.id, name: course.name }))),
                selectFirst: true
            }
        },
        showSpaceLeft: {
            title: 'Show number of places left',
            type: Boolean,
            default: true
        },
        showInfoPopupDialog: {
            title: 'Show info dialog',
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            showBookingDialog: false
        }
    },
    methods: {
        openBookingDialog() {
            this.showBookingDialog = true;
        },
        closeBookingDialog() {
            this.showBookingDialog = false;

        },
        triggerBooking() {
            this.openBookingDialog();
            if (!this.showInfoPopupDialog) {
                this.$nextTick(() => {
                    if (this.$refs.courseBooking) {
                        this.$refs.courseBooking.book();
                    }
                });
            }
        }
    }
}
</script>
